module.exports = __webpack_public_path__ + "banquet/components/AccountSettings/images/email_toggle.55cb5e4f7f34952b12d16c15004ddeff.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/AccountSettings/images/email_toggle.png
// module id = 1639
// module chunks = 1